var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-auto h-[26px] md:w-24 md:h-8",attrs:{"src":require("static/general/logo-white.svg"),"loading":"lazy","alt":"Parkos"}})
}
var staticRenderFns = []

export { render, staticRenderFns }